module.exports = __webpack_public_path__ + "media/images/kantar/logo-e6745d511d9e04163689840afbdbea9a.png";